import { render } from "./ourServices.vue?vue&type=template&id=03c6ad9d&ts=true"
import script from "./ourServices.vue?vue&type=script&lang=ts"
export * from "./ourServices.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__